class TabbedSlideshow extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.tabbed-slideshow__tab');
    this.slides = this.querySelectorAll('.tabbed-slideshow__slide');
    this.prevButton = this.querySelector('[name="previous"]');
    this.nextButton = this.querySelector('[name="next"]');
    this.tabPrevButton = this.querySelector('[name="tab-previous"]');
    this.tabNextButton = this.querySelector('[name="tab-next"]');
    this.tabsWrapper = this.querySelector('.tabbed-slideshow__tabs-wrapper');
    this.currentIndex = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed) * 1000 || 5000;
    this.autoplayInterval = null;

    if (this.slides.length === 0) return;

    this.init();
  }

  init() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.goToSlide(index));
    });

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prev());
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.next());
    }

    if (this.tabPrevButton) {
      this.tabPrevButton.addEventListener('click', () => this.prev());
    }

    if (this.tabNextButton) {
      this.tabNextButton.addEventListener('click', () => this.next());
    }

    if (this.autoplay && this.slides.length > 1) {
      this.startAutoplay();
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    this.updateButtons();
  }

  goToSlide(index) {
    if (index === this.currentIndex) return;

    if (this.tabs.length > 0) {
      this.tabs[this.currentIndex].classList.remove('tabbed-slideshow__tab--active');
    }
    this.slides[this.currentIndex].classList.remove('tabbed-slideshow__slide--active');

    this.currentIndex = index;

    if (this.tabs.length > 0) {
      this.tabs[this.currentIndex].classList.add('tabbed-slideshow__tab--active');
    }
    this.slides[this.currentIndex].classList.add('tabbed-slideshow__slide--active');

    this.centerActiveTab();
    this.updateButtons();

    if (this.autoplay) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  prev() {
    if (this.currentIndex === 0) return;
    this.goToSlide(this.currentIndex - 1);
  }

  next() {
    if (this.currentIndex === this.slides.length - 1) return;
    this.goToSlide(this.currentIndex + 1);
  }

  startAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
    this.autoplayInterval = setInterval(() => this.next(), this.speed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  centerActiveTab() {
    if (!this.tabsWrapper || this.tabs.length === 0) return;

    const activeTab = this.tabs[this.currentIndex];
    const scrollLeft = activeTab.offsetLeft - this.tabsWrapper.offsetWidth / 2 + activeTab.offsetWidth / 2;
    this.tabsWrapper.scrollTo({ left: scrollLeft, behavior: 'smooth' });
  }

  updateButtons() {
    if (this.slides.length <= 1) {
      if (this.prevButton) this.prevButton.style.display = 'none';
      if (this.nextButton) this.nextButton.style.display = 'none';
    }

    const isFirst = this.currentIndex === 0;
    const isLast = this.currentIndex === this.slides.length - 1;

    if (this.tabPrevButton) this.tabPrevButton.disabled = isFirst;
    if (this.tabNextButton) this.tabNextButton.disabled = isLast;
  }
}

customElements.define('tabbed-slideshow', TabbedSlideshow);
